import React, { useContext } from 'react'
import './index.scss'
import PointPreloader from '../../Preloaders/PointPreloader'
import MatchRecordingGroupsHeader from '@Components/MatchComponents/MatchRecordingGroups/MatchRecordingGroupsHeader'
import MatchingRecordingGroupsTable from '@Components/MatchComponents/MatchRecordingGroups/MatchingRecordingGroupsTable'
import { StoresContext } from '@App/contexts'
import MatchingHelperText from '@Components/MatchComponents/MatchRecordingGroups/MatchRecordingGroupsHeader/MatchingHelperText'
import { observer } from 'mobx-react'

interface MatchRecordingGroupsProps {
    loadMore: () => void
    loading: boolean
}

const MatchRecordingGroups = (props: MatchRecordingGroupsProps) => {
    const { loading, loadMore } = props
    const { matchingStore } = useContext(StoresContext)
    const selectedCount = matchingStore.selectedUnmatchedRecordingGroups.length
    const totalCount = matchingStore.unmatchedSearchResults?.count || 0
    const currentCount = matchingStore.unmatchedSearchResults?.recordingGroups?.length || 0
    const hasResults = !!matchingStore.unmatchedSearchResults

    return (
        <div className="unmatched-search-results">
            <MatchRecordingGroupsHeader
                totalCount={totalCount}
                currentCount={currentCount}
                selectedCount={selectedCount}
            />

            <div className="results-body">
                <>
                    {loading ? (
                        <PointPreloader />
                    ) : (
                        <>
                            {hasResults &&
                                (totalCount > 0 ? (
                                    <>
                                        <MatchingRecordingGroupsTable />
                                        {currentCount < totalCount && currentCount < 200 && (
                                            <div className="load-more-button" onClick={() => loadMore()}>
                                                <p>Load more results...</p>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <MatchingHelperText />
                                ))}
                        </>
                    )}
                </>
            </div>
        </div>
    )
}

export default observer(MatchRecordingGroups)
